import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FiTool } from 'react-icons/fi';

const Maintenance = () => (
  <div className="bg-light py-5" style={{ minHeight: '60vh' }}>
    <Container>
      <Row className="justify-content-center">
        <Col md={8} lg={6} className="text-center">
          <div className="d-inline-flex align-items-center justify-content-center bg-warning-subtle text-warning rounded-circle mb-4" style={{ width: 96, height: 96 }}>
            <FiTool size={42} />
          </div>
          <h1 className="fw-bold mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            We’ll be right back
          </h1>
          <p className="text-muted mb-4">
            The Avenue School website is currently undergoing scheduled maintenance. Please check back soon.
          </p>
          <p className="text-muted small">
            If you require urgent assistance, contact the school office on (03) 9758 0288 or email admin@theavenueschool.vic.edu.au.
          </p>
        </Col>
      </Row>
    </Container>
  </div>
);

export default Maintenance;
